import React, { useState, useEffect } from "react";
import ShippingPopup from "./ShippingPopup.js";
import { Link, useNavigate  } from "react-router-dom";
import "../styles/ShippingOptions.css";
import { getEstimatedDeliveryDate, formatDate } from "../utils/all.js"; // Assurez-vous que le chemin est correct

const ShippingOptions = ({ shippingData, shippingAddress, totalWeight }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [deliveryAddress, setDeliveryAddress] = useState(shippingAddress);
  const [showPopup, setShowPopup] = useState(false);
  const [pickupPointCarrier, setPickupPointCarrier] = useState(null);
  const [publicHolidays, setPublicHolidays] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    fetch(`https://date.nager.at/api/v3/PublicHolidays/${currentYear}/FR`)
      .then((response) => response.json())
      .then((data) => {
        const holidays = data.map((item) => item.date);
        setPublicHolidays(holidays);
      })
      .catch((error) =>
        console.error("Erreur lors de la récupération des jours fériés:", error)
      );
  }, []);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    handleValidate(option);
  };

  const handleValidate = async (option) => {
    if (option && option.service_point_input !== "none") {
      setShowPopup(true);
      setPickupPointCarrier(option.carrier);
    } else if (option) {
      deliveryAddress.pickup_point = false;
      deliveryAddress.weight = totalWeight;
      // deliveryAddress.country_code = await getCountryCode(shippingAddress.country);
      deliveryAddress.shipping_method_id = option.id;
      deliveryAddress.haveNoSignature = option.display_name === "Domicile";
      deliveryAddress.phone_number = shippingAddress.phone_number;
      // console.log("Option Domicile confirmée :", deliveryAddress);
      setDeliveryAddress(deliveryAddress);
      localStorage.setItem("deliveryAddress", JSON.stringify(deliveryAddress));
      navigate("/checkout");
    }
  };

  const handlePointRelaisSelect = async (pr) => {
    pr.address = `${pr.name} ${pr.house_number} ${pr.street}, ${pr.postal_code} ${pr.city}, ${pr.country}`;
    setShowPopup(false);

    pr.first_name = shippingAddress.first_name;
    pr.last_name = shippingAddress.last_name;
    // pr.street_number = pr.house_number;
    pr.pickup_point = true;
    pr.weight = totalWeight;
    // pr.country_code = await getCountryCode(shippingAddress.country);
    pr.shipping_method_id = selectedOption.id;
    pr.service_point_id = pr.id;
    pr.phone_number = shippingAddress.phone_number;
    // console.log("Option Point relais confirmée :", pr);
    setDeliveryAddress(pr);
    localStorage.setItem("deliveryAddress", JSON.stringify(pr));
    navigate("/checkout");
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="shipping-options">
      {/* Affichage de l'adresse de livraison avec lien Modifier */}
      <div className="address-display">
        <span>{`${deliveryAddress?.first_name} ${deliveryAddress?.last_name}`}, {deliveryAddress.street} {deliveryAddress.complement} {deliveryAddress.postal_code}, {deliveryAddress.city}</span>
        <Link to="/checkout/shipping-address">Modifier</Link>
      </div>

      {/* Options de livraison sous forme de rectangles */}
      <div className="option-rectangles">
        {shippingData.map((option) => (
          <div
            key={option.id}
            className={`option-rectangle ${
              selectedOption && selectedOption.id === option.id ? "selected" : ""
            }`}
            onClick={() => handleOptionSelect(option)}
          >
            <p style={{fontSize: 24, fontWeight: 900}}>{option.display_name}</p>
            {/* {option.service_point_input === "none" &&
              <p style={{fontSize: 16, margin: 0}}>{option.display_name === "Domicile" ? "Nous ne sommes pas reponsable en cas de non réception." : "Assurez vous de recevoir votre produit."}</p>
            } */}
            <p style={{fontSize: 16, fontWeight: 900}}>{option.service_point_input !== "none" ? "GRATUIT" : (option.display_name === "Domicile" ? "GRATUIT" : "GRATUIT")}</p>
            {/* Pour chaque pays proposé, afficher la date estimée si un délai est défini */}
            {option.countries &&
              option.countries.map((country) =>
                country.lead_time_hours ? (
                  <p key={country.id} style={{fontSize: 16}}>
                    <strong>Date estimée de livraison :</strong><br />
                    <span style={{color: '#4fb897'}}>{formatDate(getEstimatedDeliveryDate(country.lead_time_hours, publicHolidays))}</span>
                  </p>
                ) : null
              )}
          </div>
        ))}
      </div>

      {/* Bouton Valider */}
      {/* {selectedOption && (
        <button className="validate-btn" onClick={handleValidate}>
          Valider
        </button>
      )} */}

      {/* Popup pour le choix du point relais */}
      {showPopup && pickupPointCarrier && shippingAddress && (
        <ShippingPopup
          carrier={pickupPointCarrier}
          address={shippingAddress}
          onSelect={handlePointRelaisSelect}
          onClose={closePopup}
        />
      )}
    </div>
  );
};

export default ShippingOptions;
